import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ROL_TYPE } from '@app/constants/enums';
import { StorageService } from '../../storage/storage.service';
import { UserService } from '../../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class DirectionAuthGuard implements CanActivate {

  userData: any;

  constructor(
    private storage: StorageService,
    private router: Router,
    private _user: UserService
  ) { }

  async canActivate(): Promise<boolean> {
    if (this.storage.get('loggedIn') && await this.isDirection()) {
      return true;
    }
    return false;
  }

  async isDirection(): Promise<boolean> {
    let res = false;
    await this._user.checkRolType([ROL_TYPE.direction]).then(data => {
      res = data.value;
    });
    return res;
  }

}
